export default __webpack_public_path__ + "static/Wizard_09-30927d502c0e946cce0163dd8ff043f9.webp";